import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { UiOuterLink } from 'src/components/UI/OuterLink';
import { PlusSubscriptionStartGuideChatIcon } from 'src/pages/StartGuide/plusSubscription/icons/ChatIcon';
import { PlusSubscriptionStartGuideEmailIcon } from 'src/pages/StartGuide/plusSubscription/icons/EmailIcon';
import { PlusSubscriptionStartGuideHelpIcon } from 'src/pages/StartGuide/plusSubscription/icons/HelpIcon';
import { PlusSubscriptionStartGuidePhoneIcon } from 'src/pages/StartGuide/plusSubscription/icons/PhoneIcon';
import { commonSelector, deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { currentUserSelector } from 'src/store/user/selectors';
import { useTHelper } from 'src/utils/i18n';
import { openChatWidget } from 'src/utils/outer';
import { HelpCardResponseType } from 'src/models/helpCard';
import { Enums } from 'src/models/enums';

type Props = {
  data: HelpCardResponseType;
};

export const HelpCard: FC<Props> = ({ data }) => {
  const tHelper = useTHelper('helperCard');

  const bemHelper = (str?: string): string => `plussubscription-startguide-page-helper_block${str || ''}`;

  const { HelpCenterLink } = useSelector(deCommonCurrentPartnerSelector);

  const { response: userModel } = useSelector(currentUserSelector);

  const { organizationSubscriptionType } = useSelector(commonSelector);

  const supporterUser = userModel?.UserTypeCode === Enums.common.UserTypeCode.Supporter;

  const isPlusSubscription = (
    [
      Enums.organizations.OrganizationSubscriptionTypeCode.Plus,
      Enums.organizations.OrganizationSubscriptionTypeCode.Trial,
    ] as number[]
  ).includes(organizationSubscriptionType);

  /* #19934 temporarily hidden */
  // const firstName = data.ManagerFirstName || ' ';
  // const lastName = data.ManagerLastName || ' ';
  //
  // const managerName = `${firstName} ${lastName}`.trim();

  return (
    <div className={bemHelper()}>
      <h6>{tHelper('header')}</h6>
      <div className={bemHelper('-links')}>
        {data.ShowLiveChatButton && !supporterUser && (
          <div role="presentation" className={bemHelper('-link')} onClick={openChatWidget}>
            <PlusSubscriptionStartGuideChatIcon />
            {tHelper('chat')}
          </div>
        )}

        {data.HelpCardEmail && (
          <a href={`mailto:${data.HelpCardEmail}`} className={bemHelper('-link')}>
            <PlusSubscriptionStartGuideEmailIcon />
            {data.HelpCardEmail}
          </a>
        )}

        {data.HelpCardPhone && isPlusSubscription && (
          <a href={`tel:${data.HelpCardPhone}`} className={bemHelper('-link')}>
            <PlusSubscriptionStartGuidePhoneIcon />
            {data.HelpCardPhone}
          </a>
        )}

        <UiOuterLink className={bemHelper('-link')} href={HelpCenterLink}>
          <PlusSubscriptionStartGuideHelpIcon />
          {tHelper('helpCenter')}
        </UiOuterLink>
      </div>

      <div className={bemHelper('-hours')}>
        {!supporterUser && (
          <div className={bemHelper('-live-hours')}>
            <div className={bemHelper('-live-hours-title')}>{tHelper('liveHours.title')}</div>
            <div className={bemHelper('-live-hours-days')}>
              <span>{tHelper('liveHours.weekdays')}</span>
              <span>{tHelper('liveHours.weekdaysTime')}</span>
              <span>{tHelper('liveHours.weekends')}</span>
              <span>{tHelper('liveHours.weekendsTime')}</span>
            </div>
          </div>
        )}

        <div className={bemHelper('-after-hours')}>
          <div className={bemHelper('-after-hours-title')}>{tHelper('afterHours.title')}</div>
          <div className={bemHelper('-after-hours-content')}>
            <span>{tHelper('afterHours.description')}</span>
            <span>520.314.8800</span>
          </div>
        </div>
      </div>

      {/* #19934 temporarily hidden */}

      {/* <hr />
      {managerName && (
        <div className={bemHelper('-specialist_card')}>
          <div className={bemHelper('-specialist_card-header')}>{tHelper('specialistHeader')}</div>

          <div className={bemHelper('-specialist_card-personal')}>
            {data.ManagerContactPictureUrl ? (
              <img
                className={bemHelper('-specialist_card-personal-img')}
                src={data.ManagerContactPictureUrl}
                alt={managerName}
              />
            ) : (
              <div
                className={bemHelper('-specialist_card-personal-img letters')}
              >{`${firstName[0]}${lastName[0]}`}</div>
            )}
            <div className={bemHelper('-specialist_card-personal-name')}>
              <span>{managerName}</span>
              <span>{tHelper('workHours')}</span>
            </div>
          </div>
        </div>
      )}
      <div className={bemHelper('-short_description bottom')}>{tHelper('shortDescriptionMore')}</div>
      {data.ManagerEmail && (
        <a href={`mailto:${data.ManagerEmail}`} className={bemHelper('-link bottom')}>
          {tHelper('contactManager')}
        </a>
      )} */}
    </div>
  );
};
